import { Trans } from '@lingui/react/macro';

import Loader from '@/components/Loader';
import { TableQueryWrapper } from '@/components/TableQueryWrapper';
import Pagination from '@/design_system/Pagination';
import Stack from '@/design_system/Stack';
import { ShipmentWithRelations } from '@/models/shipment';
import { ShipmentsEmptyState } from '@/routes/Shipments/components/ShipmentsEmptyState';
import {
  SHIPMENTS_PER_PAGE,
  ShipmentsTable,
} from '@/routes/Shipments/Tabs/components/ShipmentsTable';
import useViewport from '@/utils/useViewport';

import { useFilters } from '../Filters/FiltersState';

import { MobileShipmentsList } from './components/MobileShipmentsList';

export const ShipmentsTab = ({
  tab,
  shipments,
  count,
  isLoading,
  isError,
}: {
  tab: 'to-do' | 'waiting' | 'all';
  shipments: ShipmentWithRelations[];
  count?: number;
  isLoading: boolean;
  isError: boolean;
}) => {
  const { isMobile } = useViewport();

  const { page } = useFilters();

  return (
    <Stack gap="1rem" style={{ height: '100%' }}>
      <TableQueryWrapper isError={isError}>
        <>
          {isMobile ? (
            <MobileShipmentsList
              shipments={shipments ?? []}
              showStepDueDate
              isLoading={isLoading}
              pagination={
                <Pagination
                  page={page.page}
                  itemsPerPage={SHIPMENTS_PER_PAGE}
                  count={count}
                  onPageChange={page.setPage}
                />
              }
            />
          ) : (
            <ShipmentsTable
              shipments={shipments ?? []}
              isLoading={isLoading}
              showStepDueDate
              pagination={{
                page: page.page,
                itemsPerPage: SHIPMENTS_PER_PAGE,
                count,
                onPageChange: page.setPage,
              }}
            />
          )}
          {isLoading ? (
            <Stack alignItems="center" justifyContent="center" style={{ flex: 1 }}>
              <Loader
                style={{
                  fontSize: '40px',
                }}
              />
            </Stack>
          ) : (
            !shipments?.length && (
              <ShipmentsEmptyState
                title={
                  tab === 'to-do' ? (
                    <Trans id="shipments.empty-state.everything-on-track-title">
                      Everything is on track!
                    </Trans>
                  ) : null
                }
                subtitle={
                  tab === 'to-do' ? (
                    <Trans id="shipments.empty-state.everything-on-track-subtitle">
                      You don't have any shipments to deal with at the moment
                    </Trans>
                  ) : (
                    <Trans id="shipments.empty-state.no-shipment-subtitle">
                      No shipments to display
                    </Trans>
                  )
                }
              />
            )
          )}
        </>
      </TableQueryWrapper>
    </Stack>
  );
};
